<div
    class="dr-label-field"
    [ngClass]="{ 'bg-padding': this.fieldOption?.backgroundColor }"
    [ngStyle]="{ 'background-color': this.fieldOption?.backgroundColor }"
>
    <lsq-icon *ngIf="!!this.fieldOption?.startIcon" [type]="renderIcon()" [color]="color.Black">
    </lsq-icon>

    <h1 class="head1" *ngIf="fieldSchema.textStyle === TextStyleEnum.Head1">
        <linked-label [links]="this.buildLabelInjected()"></linked-label>
    </h1>
    <h2 class="head2" *ngIf="fieldSchema.textStyle === TextStyleEnum.Head2">
        <linked-label [links]="this.buildLabelInjected()"></linked-label>
    </h2>
    <h3 class="head3" *ngIf="fieldSchema.textStyle === TextStyleEnum.Head3">
        <linked-label [links]="this.buildLabelInjected()"></linked-label>
    </h3>
    <h4 class="head4" *ngIf="fieldSchema.textStyle === TextStyleEnum.Head4">
        <linked-label [links]="this.buildLabelInjected()"></linked-label>
    </h4>
    <h5 class="head5" *ngIf="fieldSchema.textStyle === TextStyleEnum.Head5">
        <linked-label [links]="this.buildLabelInjected()"></linked-label>
    </h5>
    <h6 class="head6" *ngIf="fieldSchema.textStyle === TextStyleEnum.Head6">
        <linked-label [links]="this.buildLabelInjected()"></linked-label>
    </h6>
    <span
        class="normal"
        *ngIf="
            fieldSchema.textStyle === undefined || fieldSchema.textStyle === TextStyleEnum.Normal
        "
    >
        <linked-label [links]="this.buildLabelInjected()"></linked-label>
    </span>
    <hr class="division" *ngIf="this.fieldOption?.hasUnderline" />
</div>
